module.exports = __webpack_public_path__ + "static/img/11.6f9dbe1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/11.png
// module id = 8Fee
// module chunks = 0